@if (count$ | async; as stukken) {
    @switch (stukken.status) {
        @case ("loading") {
            <span class="sh-hierarchy-table__skeleton" aria-hidden="true"></span>
        }
        @case ("ready") {
            {{ stukken.count }}
        }
    }
    <!-- `unknown` renders nothing: the row is not a dossier, or its count could not be established — and a
         wrong number here would contradict the rows expanding it reveals. -->
}
